// useAlert.js
import React, { useContext } from 'react';
import { AlertContext} from "../context/AlertContext.jsx";

export const useAlert = (props) => {
    const ctx = useContext(AlertContext);
    if (!ctx) throw new Error('useAlert must be used within AlertProvider');
    return {
        alertSuccess: msg => ctx.push('success', msg),
        alertError:   msg => ctx.push('error', msg),
        alertInfo:    msg => ctx.push('info', msg),
        alertWarning: msg => ctx.push('warning', msg),
        dismissAlert: id => ctx.remove(id),
    };
}
